import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-error-wl-block',
    template: `
    <div class="col-xs-12 container-wl">
                <h1><b>You're Almost in the Right Place!</b></h1>
                <p><b>It looks like you've reached the wrong user portal.
                Simply click the button below and we'll guide you straight to the correct sign-in page</b></p>
                <a href="{{url}}" class="btn">Go to Monetum Pay Login</a>
    </div>
        `,
    styles: [`
    .container-wl {
        text-align: center;
        max-width: 400px;
        background-color: #56708b;
        border-radius: 10px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        font-weight:bold;
        font-family: 'Arial', sans-serif;
    }
    h1 {
        font-size: 20px;
        margin-bottom: 20px;
        font-weight:500;
    }
    p {
        font-size: 16px;
        line-height: 1.6;
        margin-bottom: 25px;
    }
    .btn {
        display: inline-block;
        padding: 12px 24px;
        background-color: #6bca98;
        color: white;
        text-decoration: none;
        font-weight: bold;
        transition: background-color 0.3s;
        border: none !important;
    }
    .btn:hover {
        background-color: #2980b9;
    }

        
        
        `]
})
export class ErrorWLBlock {
    @Input('url') url: string = '';

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/components/errorwl/errorwl.block.ts